export class ApiEndPointsDocument {
    AddCoreDocumentFolder = 'api/CoreDocument/AddCoreDocumentFolder';
    GetAllCoreDocumentFolders = 'api/CoreDocument/GetAllCoreDocumentFolders';
    GetAllCoreDocumentPlaceholders = "api/CoreDocument/GetAllCoreDocumentPlaceholders";
    AddCoreDocument = 'api/CoreDocument/AddCoreDocument';
    AddCoreItemForPlaceholder = 'api/CoreDocument/AddCoreItemForPlaceholder';
    AddCoreMultiDocument = 'api/CoreDocument/AddCoreMultiDocument';
    UploadCoreMultiDocumentPCC = 'api/CoreDocument/UploadCoreMultiDocumentPCC';
    GetDocumentCategoriesPCC = 'api/CoreDocument/GetDocumentCategoriesPCC';
    UploadDocumenttoPCC = 'api/CoreDocument/UploadDocumentPCC';
    UploadCoreDocument = 'api/CoreDocument/UploadCoreDocument';
    deleteDocument = 'api/CoreDocument/DeleteCoreDocument';
    DeleteCorePlaceholder = 'api/CoreDocument/DeleteCorePlaceholder';
    getDocumentsByFolder = 'api/CoreDocument/GetDocuments';
    getContacts = 'api/Contact/GetContacts';
    getNormalAndSharedContactContacts = 'api/Contact/GetContactSelectedContact';
    CreatePendingContactPCC = 'api/Core/CreatePendingContactPCC';
    getNormalAndSharedContacts = 'api/Contact/GetCoreSelectedContact';
    getNormalAndSharedCompanyContacts = 'api/Company/GetCompanySelectedContact';
    getNormalAndSharedCompanys = 'api/Company/GetCoreSelectedCompany';
    getNormalAndSharedContactCompanys = 'api/Company/GetContactSelectedCompany';
    getNormalAndSharedContactCores = 'api/Contact/GetContactSelectedCore';
    getNormalAndSharedCompanyCores = 'api/Company/GetCompanySelectedCore';
    GetContactListCoreImplementation = 'api/Contact/GetContactListCoreImplementation';
    GetCompanyListCoreImplementation = 'api/Company/GetCompanyListCoreImplementation';
    getTransactinalRoles = 'api/Contact/GetTransactinalRoles';
    addUpdateCoreContact = 'api/Contact/addUpdateCoreContact';
    addUpdateContactContact = 'api/Contact/AddUpdateContactContacts';
    addUpdateContactCompany = 'api/Company/AddUpdateContactCompany';
    addUpdateCompanyContact = 'api/Company/AddUpdateContactUnderCompany';
    addUpdateCoreCompany = 'api/Company/addUpdateCoreCompany';
    addUpdateCoreContactRole = 'api/Contact/AddUpdateCoreContactRole';
    addUpdateContactContactRole = 'api/Contact/AddUpdateContactContactRole';
    addUpdateCompanyContactRole = 'api/Company/AddUpdateContactRoleUnderCompany';
    addUpdateCoreCompanyRole = 'api/Company/AddUpdateCoreCompanyRole';
    addUpdateContactCompanyRole = 'api/Company/AddUpdateContactCompanyRole';
    deleteSelectedContact = 'api/Contact/deleteSelectedContact';
    deleteSelectedContactContact = 'api/Contact/DeleteSelectedContactContact';
    deleteSelectedCompanyContact = 'api/Company/DeleteCompanySelectedContact';
    deleteSelectedCompany = 'api/Company/DeleteSelectedCompany';
    deleteContactSelectedCompany = 'api/Company/DeleteContactSelectedCompany';
    deleteSelectedRoleCompany = 'api/Company/DeleteSelectedCompany';
    deleteSelectedRoleContactCompany = 'api/Company/DeleteContactSelectedCompany';
    addTemplate = 'api/CoreDocument/AddCoreTemplate';
    RenameCoreDocumentFolder = 'api/CoreDocument/RenameCoreDocumentFolder';
    getAllTemplates = 'api/DocumentTemplate/GetAllTemplates';
    GetDocumentTemplatePlaceholders = 'api​/DocumentTemplate​/GetDocumentTemplatePlaceholders';
    DeleteCoreDocumentFolder = 'api/CoreDocument/DeleteCoreDocumentFolder';
    appendTemplate = 'api/CoreDocument/AppendCoreTemplate';
    //getAttachment = 'api/Document/GetAttachment';
    getAttachment = 'api/App/DownloadDocument';
    getDocumentsDetailsByDocumentId = 'api/CoreDocument/GetDocumentDetails';
    UpdateDocumentsDetailsByDocumentId = 'api/CoreDocument/UpdateCoreDocumentDetails';
    getSharedAccesslRoles = 'api/ManageRole/GetAllRolesToLinkContactCompanyCore';
    GetUserList = 'api/ManageUser/GetUserList';
    AddCoreDocReviewer = 'api/CoreDocument/AddCoreDocReviewer';
    AddContactDocReviewer = 'api/ContactDocument/AddContactDocReviewer';
    getFormFolderList = 'api/FormFolder/GetFormFolder';
    getFormFolderWithFormTemplates = 'api/FormFolder/GetFormFolderWithFormTemplates';
    GetParentFormFolderHierarchy = 'api/FormFolder/GetParentFormFolderHierarchy';
    FileManagerItemsWithHierarchy = "api/FileManager/FileManagerItemsWithHierarchy";
    getFileManagerFolderList = "api/FileManager/GetFileManagerFolders";
    DownloadDocument = "api/CoreDocument/DownloadDocument";
    AddCoreDocumentfromMyDrive = "api/CoreDocument/AddCoreDocumentfromMyDrive";
    AddCreateProjectforPlaceholder = "api/CoreDocument/AddCreateProjectforPlaceholder";
    ReorderFormGroupRelations = 'api/Project/ReorderFormGroupRelations';
    AddEditProjectGroupRelationParticipant = 'api/Project/AddEditProjectGroupRelationParticipant';
    AddProjectInfoAsTemplete = "api/Project/AddProjectInfoAsTemplete";
    FillPlaceholder = "api/CoreDocument/FillPlaceholder";
    GetAllDocumentOfProjectURL = "api/CoreDocument/GetAllDocumentOfProject";
    AddProjectEventLog = "api/Project/AddProjectEventLog";
    getFormFolderSharedWithMe = 'api/FormFolder/GetFormFolderSharedWithMe';
    getFormFolderWithFormTemplatesSharedWithMe = 'api/FormFolder/GetFormFolderWithFormTemplatesSharedWithMe';
    GetSharedWithMeFileManager = "api/FileManager/GetSharedWithMeFileManager";
    GetSharedWithMeFileManagerWithHierarchy = "api/FileManager/GetSharedWithMeFileManagerWithHierarchy";

    Reorderfolders = "api/CoreDocument/Reorderfolders";
    ReorderPlaceholders = "api/CoreDocument/ReorderPlaceholders";
    ReorderPlaceholdersforNewAddedPlaceholder = "api/CoreDocument/ReorderPlaceholdersforNewAddedPlaceholder";
    ReorderfoldersforNewAddedfolder = "api/CoreDocument/ReorderfoldersforNewAddedfolder";

    extractDocumentData = "api/CoreDocument/ExtractDocumentData";
    GetFieldForImportExport = "api/Core/GetFieldForImportExport";
    addFormKeyAsNewFields = "api/Core/AddFormKeyAsNewFields";
    mergePdfFiles = "api/App/MergePdfFiles";
    addPortalAccessToContact = 'api/Contact/AddPortalAccessToContact';
    shareDocsOnPortal = "api/CoreDocument/ShareDocsOnPortal";
    searchCore = "api/Core/SearchCore";
    renameCoreDocument = "api/CoreDocument/RenameCoreDocument";
    addDocumentFileManagerTo3C="api/FileManager/AddDocumentFileManagerTo3C";
    autoFillPlaceholderForms="api/CoreDocument/AutoFillPlaceholderForms";
    autoFillCoreDataintoProject="api/CoreDocument/AutoFillCoreDataintoProject";
    getCoreUserDetails = 'api/Core/GetCoreDetail';
    setProcessStageForCoreDocumentFolder= "api/CoreDocument/SetProcessStageForCoreDocumentFolder";
    processNTAOnGivenDocuments="api/Core/ProcessNTAOnGivenDocuments";
}
